/** Tutarı Türk Lirası biçiminde gösterir: 1250 → "1.250 ₺" */
export const formatCurrencyTR = (amount) => {
  const value = Number(amount);
  if (!Number.isFinite(value) || value <= 0) return '—';
  const hasFraction = Math.round(value * 100) % 100 !== 0;
  return `${value.toLocaleString('tr-TR', {
    minimumFractionDigits: hasFraction ? 2 : 0,
    maximumFractionDigits: 2,
  })} ₺`;
};
